import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledTwitterCarouselTitle: any = styled.div`
    display: flex;
    aligh-items: center:
    justify-content: center;
    padding: 30px;
  @media (min-width: ${Breakpoints.b960}px) {
    padding: ${(props: any) => `0 ${props.theme.size.grid002}`};
    padding-bottom: 65px;
  }
`;
